import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import RingBackground from "../components/RingBackground.js";

export default function PageNotFound({ locales }) {
  return (
    <Container
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <Typography sx={{ position: "absolute" }}>
        {locales["home.codeNeeded"]}
      </Typography>
      <RingBackground />
    </Container>
  );
}
